import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/revoked.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const RevokedIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("path", { d: "M8.5 8.5h6.5a4 4 0 0 1 0 8h-5M8.5 8.5l3.2-3.2M8.5 8.5l3.2 3.2", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" })));
export const RevokedIcon = createIcon(RevokedIconGlyph, "RevokedIcon", "0 0 24 24");
//# sourceMappingURL=RevokedIcon.js.map